import { render } from "./ModalModificacionMes.vue?vue&type=template&id=b231ba4a"
import script from "./ModalModificacionMes.vue?vue&type=script&lang=js"
export * from "./ModalModificacionMes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__